export const dormantAccounts = {
  dormantAccountsGridBox: 'rounded-md! h-full p-4 bg-[#E1ECF2]',
};

export const dormantAccountsGrid = {
  stackStyle: 'h-full',
  exportBtnBox:
    'w-full p-2 border-gray-400 rounded-xs border-b-0 border bg-[#F8F8F8]',
  muiGridStyle: 'ag-theme-alpine flex-1!',
};
